
export type SearchUsers401 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
